import { page, shows, type FeatureRoutes } from "@/app/feature";

export const routes: FeatureRoutes = {
  shell: [
    {
      path: "settings/blocked",
      lazy: page(() => import("./BlockedPlayersPage")),
      handle: shows("safety"),
    },
  ],
};
